import { Context, createContext } from 'react';
import { ICareerHubModuleContext } from '../models';

export const CareerHubModuleReactContext: Context<ICareerHubModuleContext> = createContext<ICareerHubModuleContext>(
  {} as ICareerHubModuleContext
);
